<template>
    <Container :list="this.$nav20" title="校园风光" v-if="isMaxScreen">
        <div class="tsnn">
              <div class="breadcrumb">
                <router-link to="/" class="breadcrumb-item">
                  首页
                </router-link>
                -
                <span class="breadcrumb-item">
                    校园风光
                </span>
              </div>
          <div class="tsnn_top">
             <div class="tsnn_title"
                  v-for="(item, index) in list" :key="index"
                  @click="toPage(index)">
                <div :class="index === id ? 'tsnn_active': ''">{{item}}</div>
                <div v-if="index == id"
                     :class="index !== 2 ? 'tsnn_border': 'tsnn_border tsnn_border_w64'">
                </div>
             </div>
          </div>
          <ul class="tsnn_bottom">
            <li v-for="(item, index) in imgList"
                :key="item.id"
                :class="(index + 1) % 3 == 0 ? 'no_margin':''">
                <el-image
                  style="width: 280px; height: 180px"
                  :src="item.image_url"
                  :preview-src-list="srcList">
                </el-image>
                <div class="tsnn_title">{{item.title}}</div>
            </li>

          </ul>
        </div>
         <Pagination
            v-if="total"
            :total="total"
            @getList="getList"
            :queryParams="queryParams">
        </Pagination>
    </Container>

    <SceneryH5 v-else />
</template>

<script>
import Container from '@/components/Container'
import Pagination from '@/components/pagination'
import SceneryH5 from '@/views/app/scenery/index'
export default {
  name: 'Tsnn',
  components: { Container, Pagination, SceneryH5 },
  props: {},
  data () {
    return {
      isMaxScreen: true,
      list: ['校园风景', '校园生活'],
      id: 0,
      imgList: [],
      srcList: [],
      total: 0,
      queryParams: {
        type: 1,
        page: 1,
        page_size: 15
      }
    }
  },
  computed: {},
  watch: {},
  created () {
    this.getList()
  },
  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      this.isMaxScreen = document.body.clientWidth > 850
    })
  },
  methods: {
    toPage (index) {
      this.id = index
      if (index === 0) {
        this.queryParams.type = 1
        this.getList()
      } else {
        this.queryParams.type = 2
        this.getList()
      }
    },
    async getList () {
      const { data, total } = await this.$get('/ow/scenery', this.queryParams)
      this.imgList = data
      this.total = total
      for (var i = 0; i < data.length; i++) {
        this.srcList.push(data[i].image_url)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .tsnn {
     width: 890px;
     font-size: 16px;
     color: #383737;
     .tsnn_top {
        display: flex;
        justify-content: flex-start;
        padding: 14px 0;
        border-bottom: 1px solid #B3B3B3;
        margin-bottom: 16px;
        .tsnn_title {
          position: relative;
          margin-right: 32px;
          cursor: pointer;
        }
        .tsnn_border {
          position: absolute;
          left: 18px;
          bottom: -16px;
          width: 32px;
          height: 3px;
          background: #02349C;
        }
        .tsnn_border_w64 {
          width: 64px;
        }
        .tsnn_active {
          color: #02349C;
        }
     }
     .tsnn_bottom {
       display: flex;
       flex-wrap: wrap;

       li{
        margin-right: 24px;
        margin-bottom: 24px;
        position: relative;
         .tsnn_title {
           position: absolute;
           bottom: 2px;
           left: 0;
           width: 100%;
           height: 34px;
           line-height: 34px;
           font-size: 16px;
           background:  rgba(0, 0, 0, 0.5);
           color: #fff;
           text-align: center;
           overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 0 12px;
         }
       }
       .no_margin {
         margin-right: 0!important;
       }
     }
  }
</style>
